import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { ProtectionChoiceContent } from "./protectionChoiceContent/ProtectionChoiceContent";
import {
  chooseMultiple,
  chooseSingle,
  Protection,
} from "../store/wizard.actions";
import { WizardPaths } from "../../../router/WizardRouter";

import "./ProtectionChoicePage.scss";

export function ProtectionChoicePage({ choseProtection, hasMultipleSupport }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChoseProtection = (protection, path) => {
    choseProtection(protection);
    navigate(path);
  };

  const profileTypes = {
    multiple: {
      title: "multiple_profiles",
      subtitle: "multiple_profiles_info",
      description: "multiple_profiles_description",
      image: "images/profiles.svg",
      onGetProtectionClick: () =>
        dispatch(
          chooseMultiple(() =>
            handleChoseProtection(Protection.Multiple, WizardPaths.Multiple)
          )
        ),
    },
    single: {
      title: "single_profile",
      subtitle: "single_profile_info",
      description: "single_profile_description",
      image: "images/household.svg",
      onGetProtectionClick: () =>
        dispatch(
          chooseSingle(() =>
            handleChoseProtection(Protection.Single, WizardPaths.Single)
          )
        ),
    },
  };
  const itemClasses = classnames("protection-choice__item", {
    "protection-choice__item--single-option": !hasMultipleSupport,
  });

  return (
    <div className="protection-choice__container">
      <h1 className="sr-only">
        <FormattedMessage id={"protection_choice"} />
      </h1>
      {hasMultipleSupport && (
        <div className={`${itemClasses} protection-choice__item--multiple`}>
          <ProtectionChoiceContent {...profileTypes.multiple} />
        </div>
      )}
      <div className={`${itemClasses} protection-choice__item--single`}>
        <ProtectionChoiceContent {...profileTypes.single} />
      </div>
    </div>
  );
}

ProtectionChoicePage.propTypes = {
  hasMultipleSupport: PropTypes.bool.isRequired,
};
